import { Edit, Delete } from "@mui/icons-material";
import React from "react";
import { Tooltip, IconButton, Chip } from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import { setMovementId, setDefaultData } from "store/modules/StackInsumos";

const movementTypeColor = {
  ENTRADA: "success",
  SALIDA: "error",
  AJUSTE: "warning",
};

export const columns = (setOpen, setMode, setOpenDelete, dispatch) => [
  {
    field: uuidv4(),
    headerName: "Acciones",
    width: 80,
    sortable: false,
    renderCell: (data) => (
      <React.Fragment>
        <Tooltip title="Editar movimiento" placement="top">
          <IconButton
            color="primary"
            onClick={() => {
              setOpen(true);
              setMode("PUT");
              dispatch(setDefaultData(data.row));
              dispatch(setMovementId(data.row.id));
            }}
          >
            <Edit />
          </IconButton>
        </Tooltip>
        {/* <Tooltip title="Eliminar movimiento" placement="top">
          <IconButton
            color="error"
            onClick={() => {
              setOpenDelete(true);
              dispatch(setMovementId(data.row.id));
            }}
          >
            <Delete />
          </IconButton>
        </Tooltip> */}
      </React.Fragment>
    ),
  },
  {
    field: "movementType",
    headerName: "Tipo",
    width: 130,
    renderCell: (params) => (
      <Chip
        label={params.value}
        color={movementTypeColor[params.value] || "default"}
        size="small"
        sx={{
          fontFamily: "'Poppins', sans-serif",
          fontWeight: 600,
          letterSpacing: "0.05em",
        }}
      />
    ),
  },
  {
    field: "insumoNombre",
    headerName: "Insumo",
    width: 220,
    valueGetter: (params) => params.row?.variant?.insumo?.nombre || "",
  },
    {
    field: "color",
    headerName: "Color",
    width: 120,
    valueGetter: (params) => {
      const attrs = params.row?.variant?.attributes || [];
      const colorAttr = attrs.find(
        (a) => a.attributeName?.toLowerCase() === "color"
      );
      return colorAttr?.attributeValue || "-";
    },
  },
      {
    field: "medida",
    headerName: "Medida",
    width: 120,
    valueGetter: (params) => {
      const attrs = params.row?.variant?.attributes || [];
      const medidaAttr = attrs.find(
        (a) => a.attributeName?.toLowerCase() === "medida"
      );
      return medidaAttr?.attributeValue || "-";
    },
  },
  {
    field: "sku",
    headerName: "SKU",
    width: 120,
    valueGetter: (params) => params.row?.variant?.sku || "",
  },
  {
    field: "variant",
    headerName: "Stock",
    width: 120,
    type: "number",
    valueGetter: (params) => params.row?.variant?.stock || 0,
  },
  {
    field: "unit",
    headerName: "Unidad",
    width: 120,
  },
  {
    field: "variantCreatedAt",
    headerName: "Fecha",
    width: 180,
    valueGetter: (params) => {
      const date = params.row?.variant?.createdAt;
      return date ? new Date(date).toLocaleString("es-MX") : "";
    },
  },
];
